var __rspack_ns_object = {"rE":"7.12.00"}